<template>
  <div
    @mouseenter="$emit('openLearningAreas')"
    class="mega-menu__categories"
    :class="isLearningAreasActive ? 'mega-menu__categories--active' : ''"
  >
    <template v-if="categories.length">
      <div
        class="mega-menu__category"
        v-for="(category, idx) in categories"
        :style="
          `background-image: url(${
            getCategoryDetails(category.name).background
          })`
        "
        :key="`category-${idx}`"
      >
        <img
          class="mega-menu__category-name"
          :src="getCategoryDetails(category.name).name"
          :alt="category.name"
          :title="category.name"
        />
        <Topics
          @closeMegaMenu="$emit('closeMegaMenu')"
          :category="category"
          :getCategoryDetails="getCategoryDetails"
          :openCategorySearch="openCategorySearch"
        />
      </div>
    </template>
  </div>
</template>

<script>
import Topics from './Topics.vue'

export default {
  name: 'Categories',
  props: {
    categories: {
      type: Array,
      required: true,
    },
    getCategoryDetails: {
      type: Function,
      required: true,
    },
    isLearningAreasActive: {
      type: Boolean,
      required: true,
    },
    openCategorySearch: {
      type: Function,
      required: true,
    },
  },
  components: {
    Topics,
  },
}
</script>

<style lang="scss" scoped>
$mobile: 320px;
$tablet: 769px;
$desktop: 1024px;
$lg_desktop: 1300px;
.mega-menu {
  $this: &;
  &__categories {
    flex-grow: 0;
    flex-shrink: 1;
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;
    flex-basis: 50%;
    transition: all 0.3s ease;
    &--active {
      flex-basis: 100%;
    }
  }
  &__category {
    height: 100%;
    width: 80%;
    flex-grow: 0;
    flex-shrink: 1;
    position: relative;
    background-color: var(--dark-gray);
    background-size: 600px auto;
    background-position: center top;
    background-repeat: no-repeat;
    transition: all 0.2s ease-out;
    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: 500px;
      width: 1px;
      background: #222;
    }
    &:hover {
      height: 140%;
      @media screen and (min-width: $tablet) {
        width: 720%;
      }
      @media screen and (min-width: $desktop) {
        width: 360%;
      }
      @media screen and (min-width: $lg_desktop) {
        width: 180%;
      }
      #{$this}__category-name {
        max-width: 100%;
        @media screen and (min-width: $tablet) {
          top: 20px;
          left: 20px;
          max-width: 100%;
          transform: translateX(0);
        }
        @media screen and (min-width: $lg_desktop) {
          top: 45px;
          left: 45px;
          transform: translateX(0);
        }
      }
      #{$this}__category {
        background-size: 640px auto;
      }
      #{$this}__topics-wrapper {
        bottom: 0;
        transform: translateY(-65px);
        opacity: 1;
      }
    }
  }
  &__category-name {
    position: absolute;
    @media screen and (min-width: $tablet) {
      top: 20px;
      left: 50%;
      max-width: 20px;
      transform: translateX(-50%);
    }
    @media screen and (min-width: $lg_desktop) {
      top: 45px;
      left: 45px;
      max-width: 100%;
      transform: translateX(0);
    }
  }
}
</style>
